import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Loader } from 'lucide-react';
import { ROUTES } from '../../utils/constants';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const AuthLoader = () => (
  <div className="min-h-screen bg-background flex items-center justify-center">
    <div className="text-center">
      <Loader className="w-12 h-12 text-primary animate-spin mx-auto mb-4" />
      <p className="text-foreground-secondary">Yükleniyor...</p>
    </div>
  </div>
);

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user, loading, skipAuth } = useAuth();

  if (loading) return <AuthLoader />;
  if (skipAuth) return <>{children}</>;
  if (!user) return <Navigate to={ROUTES.LOGIN} replace />;
  return <>{children}</>;
};

export const RootRedirect: React.FC = () => {
  const { user, loading, skipAuth } = useAuth();
  if (loading) return <AuthLoader />;
  if (skipAuth) return <Navigate to={ROUTES.DASHBOARD} replace />;
  return <Navigate to={user ? ROUTES.DASHBOARD : ROUTES.LOGIN} replace />;
};
